import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Text from "../../components/common/Text";
import Div from "../../components/common/Div";
import LoadingBox from "../Partials/LoadingBox";
import UpdatePasswordSMSSent from "../Partials/SMSSentPopup";
import UpdateAccountMessage from "../Partials/AccountUpdateModal";
import {
  getSchoolName,
  getSchools,
  updateForgotPasswordSMS,
  updateProfile,
} from "../../api/admin";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { FixedSizeList as List } from "react-window";

export default function EditAccount(props) {
  const history = useHistory();
  const user = props.user.student;
  var gradeList;
  if (
    user.grade === "Teacher" ||
    user.grade === "SP" ||
    user.grade === "SP" ||
    user.grade === "FET"
  )
    gradeList = ["FET", "SP", "Other"];
  else gradeList = [8, 9, 10, 11, 12];

  const fullName = user.name.concat(" ").concat(user.surname);
  const defaultGrade = user.grade;
  const defaultContact = user.contactnr;
  const gender = user.gender;

  const [grade, setGrade] = useState(
    user.grade === "Teacher" ? "Other" : user.grade
  );
  const [contactnr, setContactnr] = useState(user.contactnr);
  const [schoolId, setSchoolId] = useState(user.school_id);

  const [schoolList, setSchoolList] = useState([]);
  const [schoolName, setSchoolName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDescription, setModalDescription] = useState("");
  const [isUpdatePasswordDisabled, setIsUpdatePasswordDisabled] =
    useState(false);
  const [isUpdateButtonDisabled, setIsUpdateButtonDisabled] = useState(false);

  const UpdatePassword = async () => {
    setIsUpdatePasswordDisabled(true);

    const smsResponse = await updateForgotPasswordSMS(
      user.id_num,
      user.contactnr
    );

    if (smsResponse.code === 200) {
      setShowPasswordModal(true);
      setModalTitle("SMS Successfully Sent");
      setModalDescription("SMS successfully sent to your mobile number.");
    } else {
      setShowPasswordModal(true);
      setModalTitle("SMS Not Sent");
      setModalDescription(
        "There was an error sending the SMS to your mobile number."
      );
    }

    setTimeout(() => {
      setIsUpdatePasswordDisabled(false);
    }, 5000);
  };

  useEffect(() => {
    const abortController = new AbortController();
    getSchoolList();
    return () => {
      abortController.abort();
    };
  }, []);

  const getSchoolList = async () => {
    setIsLoading(true);
    const schoolsResponse = await getSchools();
    setSchoolList(schoolsResponse.data);
    GetSchoolName();
  };

  const GetSchoolName = async () => {
    const schoolResponse = await getSchoolName(user.school_id.toString());
    setIsLoading(false);
    setSchoolName(schoolResponse.data.name);
  };

  const onGradeChange = (e) => {
    setGrade(e.target.value);
  };

  const onSchoolChange = (e) => {
    setSchoolId(e.target.value);
  };

  const onContactChange = (e) => {
    setContactnr(e.target.value);
  };

  const Update = async () => {
    setIsUpdateButtonDisabled(true);

    const student = {
      name: user.name,
      surname: user.surname,
      grade: grade,
      contactnr: contactnr,
      gender: gender,
      school: schoolId,
      token: user.token,
    };

    const updateAccountResponse = await updateProfile(
      student.name,
      student.surname,
      student.grade,
      student.contactnr,
      student.gender,
      student.school,
      student.token
    );

    if (updateAccountResponse.code === 200) {
      setShowUpdateModal(true);
    } else {
      console.log(updateAccountResponse);
    }

    setTimeout(() => {
      setIsUpdateButtonDisabled(false);
    }, 5000);
  };

  return (
    <div style={{ backgroundColor: "#00112e", boxSizing: "border-box" }}>
      <LoadingBox display={isLoading} />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#212a41",
          padding: "15px",
          borderRadius: "5px",
          boxSizing: "border-box",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#FBCD02",
            fontSize: "1.1rem",
            textAlign: "left",
          }}
        >
          Profile Information
        </Typography>

        <hr
          style={{
            marginBottom: "20px",
            borderColor: "#FBCD02",
            borderWidth: "1px",
            borderStyle: "solid",
            width: "100%",
          }}
        />

        <div style={{ marginTop: "10px" }}>
          <TextField
            id="fullName"
            value={fullName}
            label="Full Name"
            InputProps={{
              readOnly: true,
              sx: {
                padding: "5px",
                borderRadius: "5px",
                backgroundColor: "#00122d",
                color: "white",
                "& .MuiInputBase-input": {
                  padding: "10px",
                  color: "white",
                },
                "&.Mui-focused": {
                  borderColor: "#00122d",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "#fbcd02",
                "&.Mui-focused": {
                  color: "#fbcd02",
                },
              },
            }}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  borderColor: "#fbcd02",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fbcd02",
                },
              },
            }}
          />
        </div>

        <div
          style={{
            textAlign: "left",
            color: "#fbcd02",
            fontSize: "13px",
            padding: "10px",
            maxWidth: "100%",
          }}
        ></div>
        <div>
          <TextField
            label="Username"
            id="username"
            value={user.id_num}
            InputProps={{
              readOnly: true,
              sx: {
                padding: "5px",
                borderRadius: "5px",
                backgroundColor: "#00122d",
                color: "white",
                "& .MuiInputBase-input": {
                  padding: "10px",
                  color: "white",
                },
                "&.Mui-focused": {
                  borderColor: "#00122d",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "#fbcd02",
                "&.Mui-focused": {
                  color: "#fbcd02",
                },
              },
            }}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  borderColor: "#fbcd02",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fbcd02",
                },
              },
            }}
          />
        </div>

        <div
          style={{
            marginTop: "20px",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
          }}
        >
          <div>
            <TextField
              label="Grade"
              id="grade"
              value={user.grade}
              InputProps={{
                readOnly: true,
                sx: {
                  padding: "5px",
                  borderRadius: "5px",
                  backgroundColor: "#00122d",
                  color: "white",
                  "& .MuiInputBase-input": {
                    padding: "10px",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00122d",
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "#fbcd02",
                  "&.Mui-focused": {
                    color: "#fbcd02",
                  },
                },
              }}
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    borderColor: "#fbcd02",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#fbcd02",
                  },
                },
              }}
            />
          </div>
          `
          <div>
            <TextField
              label="School"
              id="school"
              value={schoolName}
              InputProps={{
                readOnly: true,
                sx: {
                  padding: "5px",
                  borderRadius: "5px",
                  backgroundColor: "#00122d",
                  color: "white",
                  "& .MuiInputBase-input": {
                    padding: "10px",
                    color: "white",
                  },
                  "&.Mui-focused": {
                    borderColor: "#00122d",
                  },
                },
              }}
              InputLabelProps={{
                sx: {
                  color: "#fbcd02",
                  "&.Mui-focused": {
                    color: "#fbcd02",
                  },
                },
              }}
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    border: "none",
                  },
                  "&:hover fieldset": {
                    borderColor: "#fbcd02",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#fbcd02",
                  },
                },
              }}
            />
          </div>
        </div>

        <div
          style={{
            textAlign: "left",
            color: "#fbcd02",
            fontSize: "13px",
            padding: "10px",
            width: "90%",
          }}
        ></div>
        <Div>
          <TextField
            label="Gender"
            id="gender"
            value={user.gender}
            InputProps={{
              readOnly: true,
              sx: {
                padding: "5px",
                borderRadius: "5px",
                backgroundColor: "#00122d",
                color: "white",
                "& .MuiInputBase-input": {
                  padding: "10px",
                  color: "white",
                },
                "&.Mui-focused": {
                  borderColor: "#00122d",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "#fbcd02",
                "&.Mui-focused": {
                  color: "#fbcd02",
                },
              },
            }}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  borderColor: "#fbcd02",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fbcd02",
                },
              },
            }}
          />
        </Div>

        <div
          style={{
            textAlign: "left",
            color: "#fbcd02",
            fontSize: "13px",
            padding: "10px",
            width: "90%",
          }}
        ></div>
        <div>
          <TextField
            label="Contact Number"
            value={defaultContact}
            InputProps={{
              readOnly: true,
              sx: {
                padding: "5px",
                borderRadius: "5px",
                backgroundColor: "#00122d",
                color: "white",
                "& .MuiInputBase-input": {
                  padding: "10px",
                  color: "white",
                },
                "&.Mui-focused": {
                  borderColor: "#00122d",
                },
              },
            }}
            InputLabelProps={{
              sx: {
                color: "#fbcd02",
                "&.Mui-focused": {
                  color: "#fbcd02",
                },
              },
            }}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  borderColor: "#fbcd02",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#fbcd02",
                },
              },
            }}
          />
        </div>

        <Div padding={"10px 0"}>
          <div>
            <button
              style={{
                cursor: "pointer",
                marginTop: "15px",
                fontSize: "0.9rem",
                fontWeight: "bold",
                backgroundColor: "#FBCD02",
              }}
              className="button"
              onClick={UpdatePassword}
              disabled={isUpdatePasswordDisabled}
            >
              Update Password
            </button>
          </div>
          <div>
            {/* <button
              style={{ cursor: 'pointer' }}
              className='buttonUpdate'
              onClick={Update}
              disabled={isUpdateButtonDisabled}
            >
              Update
            </button> */}
          </div>
        </Div>
      </div>

      <UpdateAccountMessage
        display={showUpdateModal}
        handler={() => setShowUpdateModal(false)}
      />

      <UpdatePasswordSMSSent
        display={showPasswordModal}
        handler={() => setShowPasswordModal(false)}
        title={modalTitle}
        message={modalDescription}
      />
    </div>
  );
}
